export const AccommRsvListActions = {
  SET_RSV_VALUE: '@@AccommRsvList/SET_RSV_VALUE',
};
